.toolbar {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  flex-wrap: wrap;
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--border-subtle);
  background: var(--bg-surface);
}

.search {
  flex: 1;
  min-width: 200px;
  max-width: 340px;
}

.spacer {
  flex: 1;
}

.count {
  font-size: var(--text-sm);
  color: var(--text-tertiary);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.skipped {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-4);
  border-top: 1px solid var(--border-subtle);
  background: var(--warning-subtle);
  color: var(--text-secondary);
  font-size: var(--text-sm);
}

.skippedIcon {
  color: var(--warning);
  flex-shrink: 0;
}
